import { TissueLabelName } from "./tissue-labels";

export const dashboardShortcut = [
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-', '=',
  '[', ']',
  'a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ';', '\'', '#',
  'shift + a', 'shift + s', 'shift + d', 'shift + f', 'shift + g', 'shift + h', 'shift + j', 'shift + k', 'shift + l', 'shift + ;', 'shift + \'', 'shift + #',
  'z' , 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '/',
  'shift + z' , 'shift + x', 'shift + c', 'shift + v', 'shift + b', 'shift + n', 'shift + m', 'shift + ,', 'shift + .', 'shift + /',
  'space' , 'shift + space', 'alt + wheel-scroll', 'up', 'down', 'alt + a', 'alt + s', 'alt + g', 'alt + z', 'alt + x', 'alt + c', 'alt + v', 'alt + b', 'alt + -', 'alt + =',
] as const;
export type DashboardShortcut = typeof dashboardShortcut[number];

export const tissueShortcut = ['q' , 'w', 'e', 'r' , 't', 'y', 'u' , 'i', 'o', 'p', 'alt + q' , 'alt + w', 'alt + e', 'alt + r' , 'alt + t', 'alt + y', 'alt + u' , 'alt + i', 'alt + o', 'alt + p', 'alt + h', 'alt + j', 'alt + k', 'alt + l', 'alt + ;', 'alt + n', 'alt + m', 'alt + ,', 'alt + .', 'alt + /', 'alt + 1', 'alt + 2', 'alt + 3', 'alt + 4', 'alt + 5', 'alt + 6', 'alt + 7', 'alt + 8', 'alt + 9', 'alt + 0'] as const;

export type TissueShortcut = typeof tissueShortcut[number];

export type ShortcutOverlap = DashboardShortcut & TissueShortcut

// eslint-able-next-line @typescript-eslint/no-unused-vars
const _dummyEmptyCheck: Record<ShortcutOverlap, string> = {}

export type HotkeyModelMap = Partial<Record<TissueLabelName, TissueShortcut>>

export type HotkeyActionName = 'axial' | 'saggital' | 'coronal' | 'threedD' | 'quadView'
export type HotkeyDashboardMap = Partial<Record<HotkeyActionName, DashboardShortcut>>

export const HOTKEY_DASHBOARD_MAP: HotkeyDashboardMap = {
  axial:    'z',
  saggital: 'x',
  coronal:  'c',
  threedD:  'v',
  quadView: 'b',
}
